import React, { useState, useContext, useEffect } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";

import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Stack from "@mui/material/Stack";
import GeneralContext from "../GeneralContext/GeneralContext";
import InputFilter from "../GeneralComponents/InputFilter";
import axios from "../../api/axios";

import PageBody from "../GeneralComponents/PageBody";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { CircularProgress } from '@mui/material';
import ListStepper from "../GeneralComponents/ListStepper";
import ListEmpty from "../GeneralComponents/ListEmpty";
import PrefacturaAlert from "../GeneralComponents/PrefacturaAlert";

import PrefacturaOpCard from "./PrefacturaOpCard";
import PrefacturaCard from "./PrefacturaCard";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import {NO_SUBTEL, NO_MINEDUC, REJECTED, APROVED, ROL_ADMIN, ROL_OP_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_CON_MINEDUC, ROL_VAL_MINEDUC, PERIODS} from "../../Constants/Constants";


let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);





export default function PrefacturaDetails() {
  const { userSesion } = useContext(GeneralContext);
  const [rows, setRows] = useState([]);
  const { includeRol, pageTitle, setPageTitle } = useContext(GeneralContext);
  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState(rows);
  const [loadingTable, setLoadingTable] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [operadorId, setOperadorId] = useState(0);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [loadingPDF, setLoadingPDF] = useState(false);

  const navigate = useNavigate();
  const { id, periodo } = useParams();
  const [period, setPeriod] = useState(
        periodo && PERIODS.includes(periodo) ? periodo : PERIODS[1]
    );


  const canSign = (estado) => {
    if (
      estado === NO_SUBTEL &&
      includeRol([ROL_VAL_SUBTEL])
    ) 

    return false;
  };


    const downloadPDF = (url) => {
      setLoadingPDF(true);
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');

                a.href = blobUrl;
                a.download = 'download.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(blobUrl);
                setLoadingPDF(false);
            })
            .catch((error) => {setLoadingPDF(false); console.error('Error al descargar el archivo:', error); window.open(url, '_blank'); });
    };


async function getOperator() {
  try {
    const response = await axios.getOperator(userSesion.rut);
    const operadorId = response.data.id_operador;
    return operadorId;
  } catch (error) {
    console.error("Error al obtener el operador:", error);
    throw error;
  }
}
  const fetchData = async (periodo) => {
  setPeriod(periodo);
  setLoadingTable(true);
  try {
    let operador = id; 
    if (!operador) {
      operador = await getOperator();
      setOperadorId(operador);
    }
    // Llamar al endpoint con el operador obtenido
    const response = await axios.getPrefacturasV2(periodo+"?id_operador="+operador);
    const modifiedData = response.data.map((row) => ({
      ...row,
            diff: row["diferencia"] ? "CON DIFERENCIAS" : "SIN DATOS",
            color: row["diferencia"] ? "#C489D9" : "#E6E6E6",
            codigo: row["codigo_prefactura"] ? row["codigo_prefactura"] : "-",
            diff_action: "",
            periodo: row.periodo.slice(0, 7),
            fecha_prefactura: row.periodo.slice(0, 10),
            estado_validacion: row["estado"] ? row["estado"] : "Pendiente"
    }));

    setRows(modifiedData);
    setTableData(modifiedData);
  } catch (error) {
    console.error("Error en fetchData:", error);
    setRows([])
    setTableData([])
  } finally {
    setLoadingTable(false);
  }
};

  useEffect(() => {
    fetchData(period);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const refreshData = (name: String, value: any) => {
    if(value){
    fetchData(value);
  }
  };


  const filterRecords = (name: String, value: any) => {
    let filterObj = { ...filters };
    filterObj[name] = value;
    setFilters(filterObj);
    if (value == null) {
      delete filterObj[name];
    }
    if (Object.keys(filterObj).length !== 0) {
      setTableData([
        ...tableData.filter((item) =>
          Object.entries(filterObj).every(([key, value]) => item[key] === value)
        ),
      ]);
    } else {
      setTableData(rows);
    }
  };


  useEffect(() => {
    setPageTitle("LISTADO APELACIONES PRE-FACTURA");
  }, [pageTitle, setPageTitle]);

  return (

    <PageBody>
    <PrefacturaAlert/>
      <Box width="100%">
          <Grid
            container
            spacing={1}
            sx={{ marginBottom: "28px" }}
          >

            <Grid size={3}>
          <InputFilter
            opt={PERIODS}
            data={rows}
            value={period}
            item={"period"}
            name={"Periodo"}
            callback={refreshData}
          />
        </Grid>
          </Grid>
        



        {loadingTable ?
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
                width: '100%',
                backgroundColor: 'white'
              }}
            >
              <CircularProgress />
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cargando...
              </Typography>
            </Box>
            :
        <Box>
          {tableData.length === 0 ? (<ListEmpty msg="No hay prefacturas registradas para este periodo."/>) : null}
                      <Box display="flex" flexWrap="wrap" justifyContent="left">
            {tableData
              .map((data, index) => (
                <PrefacturaCard key={index} data={data} dataDev={null} fetch={fetchData} showZonas={true}/>
              ))}
          </Box>
        </Box>

          }
       
      </Box>
    </PageBody>
  );
}

